import { api_GET } from "../api/_axios.js";

const dashboard_api =
{
    get: function () {
        const promise = new Promise((resolve, reject) => {
            api_GET(`dashboard`).then(result => {
                resolve(result)
            });
        });

        return promise;
    },
}

export default dashboard_api
